<head>

</head>

<script>
  import ViewSteps from "./ViewSteps.svelte";
  import { UnitsStore, ReadingsStore, UnitOptions } from "../stores.js";
  import { fade } from "svelte/transition";

  export let Index;

  export let Deletable = false;
  export let ID = Index;

  export let altitude = undefined;
  export let distance = undefined;
  export let angle = undefined;
  export let steps = [];
  export let building_height = 0;

  let ValidationError = false;
  let nodeRef;

  function getUnits() {
    return $UnitOptions;
  }

  function radians_to_degrees(radians) {
    var pi = Math.PI;
    return radians * (180 / pi);
  }

  function getTanFromDegrees(degrees) {
    return radians_to_degrees(Math.tan((degrees * Math.PI) / 180));
  }

  function ghps(height, distance, units, angle_diff) {
    height = Number(height);
    distance = Number(distance);
    angle_diff = Number(angle_diff);

    let tan_of_angle_diff = getTanFromDegrees(angle_diff);
    let calculated_height = height * tan_of_angle_diff;
    let total_height = (Number(calculated_height) + Number(height)).toFixed(2);

    console.log(
      height,
      distance,
      angle_diff,
      tan_of_angle_diff,
      calculated_height,
      total_height
    );

    let tan_anglediff_clean = `${angle_diff.toFixed(2)}`;
    let calculated_height_clean = `${calculated_height.toFixed(2)} ${units}`;
    let total_height_clean = `${total_height} ${units}`;
    let user_height_clean = `${height.toFixed(2)} ${units}`;
    let object_distance_clean = `${distance} ${units}`;

    let math_jax_steps = [
      String.raw`\tan\left(90° - \textrm{(Angle when looking at top of building)}°\right) = \dfrac{\textrm{(Height of Object)}}{\textrm{(Distance between Person and Object)}}`,
      String.raw`\tan\left(90° - ${90 -
        angle_diff}°\right) = \dfrac{\textrm{(Height of Object)}}{${object_distance_clean}}`,
      String.raw`\tan\left(${angle_diff}°\right) \times ${object_distance_clean} = \textrm{(Height of Object)}`,
      String.raw`${tan_anglediff_clean} \times ${object_distance_clean} = \textrm{(Height of Object)}`,
      String.raw`\textrm{Height of Object} = ${calculated_height_clean}`,
      String.raw`\textrm{Total Height of Object} = ${calculated_height_clean} + ${user_height_clean}`,
      String.raw`\textrm{Total Height of Object} = ${total_height_clean}`
    ];

    return {
      total_height: total_height,
      steps: {
        mathjax: math_jax_steps
      }
    };
  }

  async function getHeightPopulateSteps() {
    try {
      const data = ghps(altitude, distance, $UnitsStore, angle);
      console.log(data);
      steps = (data.steps || { mathjax: [] }).mathjax;
      // console.log(`${Index} - ${steps}`);
      building_height = data.total_height;
      return;
    } catch (error) {
      console.log(error);
      building_height = 69;
      return;
    }
  }

  function getRand() {
    return Array(5)
      .fill()
      .map(() => ((Math.random() * 36) | 0).toString(36))
      .join("");
  }

  let timeout = -1;
  $: {
    if (
      $UnitsStore !== undefined &&
      $UnitsStore !== "Units" &&
      $UnitsStore !== ""
    ) {
      if (
        altitude !== undefined &&
        distance !== undefined &&
        angle !== undefined
      ) {
        if (timeout != -1) clearTimeout(timeout);
        timeout = setTimeout(getHeightPopulateSteps, 250);
      }
    }
  }

  function DeleteSelf() {
    let copy = $ReadingsStore.map(function(el, idx) {
      if (idx == Index) {
        return undefined;
      } else {
        return el;
      }
    });
    $ReadingsStore = copy.filter(Boolean);
    // console.log("Called delete self with index " + Index);

    // nodeRef.parentNode.removeChild(nodeRef)
  }

  $: {
    $ReadingsStore[Index] = {
      user_height: altitude,
      object_distance: distance,
      units: $UnitsStore,
      angle_difference: angle,
      building_height: building_height,
      steps: steps || []
    };
  }
</script>

<style>
  /* Prevents updown arrows from showing on number fields, https://www.w3schools.com/howto/howto_css_hide_arrow_number.asp */

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type="numbe"] {
    -moz-appearance: textfield;
  }
</style>

<div class="card w-96 m-5 shadow-xl bg-primary" id={ID} bind:this={nodeRef} transition:fade={{ delay: 50 }}>
  <div class="card-body">

    
    <div class="card-actions justify-end">
    {#if Deletable}
      <button class="btn btn-square btn-sm" on:click={DeleteSelf}>
        X
      </button>
    {:else}
      <button class="btn btn-square btn-sm btn-disabled" data-tip="There needs to be atleast one reading.">
        X
      </button>
    {/if}
    </div>
    
    
    <div class="card-actions justify-center">
      <h2 class="card-title">
        Reading #{Index+1}
      </h2>

      {#if ValidationError}
      <div class="alert alert-error shadow-lg m-2" in:fade out:fade>
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" class="stroke-current flex-shrink-0 h-6 w-6" fill="none" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
          <span>Please check your Input!</span>
        </div>
      </div>
      {/if}

      <div class="pl-3 px-5">
        <div class="">
          <label class="label">
          <span class="label-text">Altitude of Clinometer</span>
          </label>
          <input bind:value={altitude} type="numbe" placeholder="(In {$UnitsStore})" class="input input-bordered input-secondary w-full max-w-xs" />
        </div>

        <div class="pt-3">
          <label class="label">
          <span class="label-text">Distance from Object</span>
          </label>
          <input bind:value={distance} type="numbe" placeholder="(In {$UnitsStore})" class="input input-bordered input-secondary w-full max-w-xs" />
        </div>

        <div class="pt-3">
          <label class="label">
          <span class="label-text">Angle</span>
          </label>
          <input bind:value={angle} type="numbe" placeholder="(In Degrees)" class="input input-bordered input-secondary w-full max-w-xs" />
        </div>
      </div>

      <div class="justify-center mt-3">
        <h3><strong>Height: {building_height} {$UnitsStore}</strong></h3>

        <div class="mt-5 flex flex-row flex-wrap">
          <div class="mr-3">
            <select bind:value={$UnitsStore} class="select select-bordered">
              <option disabled selected>Units</option>
              {#each getUnits() as unitObject (unitObject.id)}
                <option value={unitObject.id}>{unitObject.name}</option>
              {/each}
            </select>
          </div>
          <div class="ml-3">
            <ViewSteps Index={Index} steps={steps}/>
          </div>
        </div>

      </div>
    </div>

    

    

  </div>
</div>
